import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {ChallengeType} from "@/modules/redactor/models/challenge/ChallengeType";

export class ChallengeConfig extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._type = null;
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!this.type || !ChallengeType.is(this.type)) {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ChallengeConfig());
        } else if (target instanceof ChallengeConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ChallengeConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _type: alias("type", ChallengeType.schema()),
    _reward: alias("reward", RewardBunch.schema())
});